<template>
  <div v-if="showPopup" class="yandex-metrika-popup">
    <div class="popup-content">
      <p class="popup-text">Этот сайт использует сервис веб-аналитики Яндекс Метрика</p>
      <div class="popup-buttons">
        <button @click="showDetails" class="details-button">Подробнее</button>
        <button @click="dismissAndStore" class="modal-close"></button>
      </div>
    </div>

    <dialog ref="detailsDialog" @click="closeModalOnBackdropClick">
      <div class="dialog-content">
        <button @click="closeDetails" class="modal-close"></button>
        <h3>Информирование об использовании Яндекс.Метрики</h3>
        <p>Этот сайт использует сервис веб-аналитики Яндекс Метрика, предоставляемый компанией ООО «ЯНДЕКС», 119021, Россия, Москва, ул. Л. Толстого, 16 (далее — Яндекс).</p>
        <p>Сервис Яндекс Метрика использует технологию “cookie” — небольшие текстовые файлы, размещаемые на компьютере пользователей с целью анализа их пользовательской активности.</p>
        <p>Собранная при помощи cookie информация не может идентифицировать вас, однако может помочь нам улучшить работу нашего сайта. Информация об использовании вами данного сайта, собранная при помощи cookie, будет передаваться Яндексу и храниться на сервере Яндекса в ЕС и Российской Федерации. Яндекс будет обрабатывать эту информацию для оценки использования вами сайта, составления для нас отчетов о деятельности нашего сайта, и предоставления других услуг. Яндекс обрабатывает эту информацию в порядке, установленном в условиях использования сервиса Яндекс Метрика.</p>
        <p>Вы можете отказаться от использования cookies, выбрав соответствующие настройки в браузере. Также вы можете использовать инструмент — <a href="https://yandex.ru/support/metrika/general/opt-out.html" target="_blank" rel="noopener noreferrer">https://yandex.ru/support/metrika/general/opt-out.html</a> Однако это может повлиять на работу некоторых функций сайта. Используя этот сайт, вы соглашаетесь на обработку данных о вас Яндексом в порядке и целях, указанных выше.</p>
      </div>
    </dialog>
  </div>
</template>

<script>
export default {
    name: "YandexMetrikaPopup",
    data() {
        return {
            showPopup: false
        };
    },
    mounted() {
        if (!localStorage.getItem("yandexMetrikaConsentDismissed")) {
            setTimeout(() => {
                this.showPopup = true;
            }, 1500);
        }
    },
    methods: {
        dismissAndStore() {
            localStorage.setItem("yandexMetrikaConsentDismissed", "true");
            this.showPopup = false;
        },
        showDetails() {
            this.$refs.detailsDialog.showModal();
        },
        closeDetails() {
            this.$refs.detailsDialog.close();
            // Do not dismissAndStore here, the user wants the popup to remain visible
        },
        closeModalOnBackdropClick(event) {
            if (event.target === this.$refs.detailsDialog) {
                this.closeDetails();
            }
        }
    }
};
</script>

<style scoped>
.yandex-metrika-popup {
    position: fixed;
    bottom: 18px;
    right: 18px;
    background-color: #171d29;
    border: 2px solid #24b0bf;
    color: #fff;
    padding: 10px;
    z-index: 10000;
}

.mobile .yandex-metrika-popup {
    left: 18px;
}

.popup-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.popup-text {
    font-family: var(--font-base);
    font-size: 14px;
}

.popup-buttons {
    display: flex;
    gap: 10px;
}

.details-button {
    background: none;
    border: 2px solid #24b0bf;
    background-color: 24b0bf;
    color: #fff;
    font-family: var(--font-base);
    font-size: 14px;
    padding: 6px 10px;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
    font-weight: 500;
}

.yandex-metrika-popup .modal-close {
    position: relative;
    width: 30px;
    height: 30px;
    background-color: #ff7445;
}

.dialog-content .modal-close {
    position: absolute;
    top: 0;
    right: 0;
    height: 40px;
    width: 40px;
}

dialog {
    color: #171d29;
    padding: 0;
    border: 0;
    max-width: 760px;
    z-index: 10001;
}

dialog::backdrop {
    background: rgba(0, 0, 0, 0.7);
}

.dialog-content {
    padding: 30px;
    padding-top: 50px;
    position: relative;
}

.dialog-content .modal-close {
    background-color: #ff7445;
    right: 0;
    top: 0;
}

.dialog-content h3 {
    font-family: var(--font-title);
    font-size: 28px;
    margin-bottom: 1em;
    color: #171d29;
}
.dialog-content p {
    font-family: var(--font-base);
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 1em;
}
.dialog-content a {
    color: #24b0bf;
    text-decoration: underline;
}
.dialog-content a:hover {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/YandexMetrikaPopup.vue